import { render, staticRenderFns } from "./SuccessfulChargeWalletPayment.vue?vue&type=template&id=4f1e66a0"
import script from "./SuccessfulChargeWalletPayment.vue?vue&type=script&lang=js"
export * from "./SuccessfulChargeWalletPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports